function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.304 1.964C3.21 4.569.368 11.652 2.958 17.782c2.59 6.13 9.632 8.989 15.727 6.383.81-.346 1.564-.772 2.254-1.264l6.318 6.779c.38.408 1.018.429 1.424.046a1.018 1.018 0 00.046-1.433l-6.246-6.702a12.117 12.117 0 002.55-13.244C22.441 2.217 15.4-.641 9.304 1.964zm-4.49 15.025c-2.156-5.1.208-10.992 5.279-13.16 5.07-2.167 10.928.21 13.083 5.31 2.155 5.101-.208 10.993-5.28 13.16-5.07 2.168-10.928-.21-13.083-5.31z",
  fill: "currentColor"
})));